import React from "react";

const Java_Debugging = () => {
  return (
    <div>
      <h1>Java Debugging</h1>
      <p>This page provides explanations, examples, and common use-cases for Java Debugging in Java.</p>
    </div>
  );
};

export default Java_Debugging;
